import { PostNetworkType } from '@sprinklr/stories/post/Post';

export const SYMBOL_SCREEN_NAMES: PostNetworkType[] = ['twitter', 'x', 'instagram', 'youtube'];
